import { hotTags, siteMeta } from "@/mocks/gossipData";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div className="mx-auto max-w-7xl px-4 pb-12 pt-24 md:px-6 md:pb-16 md:pt-32">
        <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="relative z-10">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-sparkling-2-fill"></i>
              {siteMeta.weekly} 本周盘点已更新
            </span>

            <h1 className="font-heading mt-5 text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              本周吃瓜焦点
              <br />
              <span className="text-primary-600">一次看够近期动态</span>
            </h1>

            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              从娱乐八卦到社会热议，我们把本周最劲爆的瓜料与最新进展汇总在同一个页面。
              省去翻找时间，直达近期不可错过的热门话题。
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <a
                href="#feed"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                开始看本周瓜料
              </a>
              <a
                href="#focus"
                className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-center text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                查看焦点热榜
              </a>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              {hotTags.map((t) => (
                <span
                  key={t}
                  className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700 ring-1 ring-background-300"
                >
                  <span className="mr-1 text-primary-500">#</span>
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="relative hidden lg:block">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20collage%20illustration%20of%20entertainment%20gossip%20hot%20topics%2C%20theatre%20curtain%20and%20film%20reels%20with%20floating%20headline%20tickets%20and%20spotlights%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20collage%20of%20cameras%20popcorn%20and%20speech%20bubbles%2C%20vibrant%20but%20soft%2C%20editorial%20magazine%20art%2C%20high%20detail&width=900&height=720&seq=hero-main-2026&orientation=portrait"
                alt="吃瓜热门本周焦点盘点主视觉"
                className="h-[460px] w-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-600/20 to-transparent"></div>
            </div>

            <div className="absolute -left-5 top-8 rounded-xl bg-background-50/95 px-4 py-3 shadow-sm ring-1 ring-background-200">
              <p className="text-xs text-foreground-500">今日热搜</p>
              <p className="mt-1 flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <i className="ri-fire-line text-primary-500"></i>番位之争持续发酵
              </p>
            </div>
            <div className="absolute -right-3 bottom-10 rounded-xl bg-accent-500 px-4 py-3 shadow-sm">
              <p className="text-xs text-accent-950">更新于</p>
              <p className="mt-1 text-sm font-bold text-accent-950">09-07 09:30</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}